import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "closed-deposit-detail-table px-4 py-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "SNACK"),
  /*#__PURE__*/_createElementVNode("th", null, "HARGA"),
  /*#__PURE__*/_createElementVNode("th", null, "TERJUAL"),
  /*#__PURE__*/_createElementVNode("th", null, "SISA"),
  /*#__PURE__*/_createElementVNode("th", null, "PENDAPATAN")
], -1)
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center text-xs text-grey p-2",
  style: {"text-align":"center"}
}, "Tidak Ada Data", -1)
const _hoisted_7 = [
  _hoisted_6
]

import {
  ref,
  toRefs,
  computed,
  watch,
  onMounted
} from 'vue'
import defaulListImage from '@/assets/img/icon/cross-black-background-grey.svg'
import numberFormat from '@/utils/helpers/numberFormat'
import currencyNumberFormat from '@/utils/helpers/rupiahFormat'
import '../../detail-table.scss'
import { useStore } from 'vuex'
import apiUseCase from '@/usecase/apiUseCase'
import environment from '@/configs/environtment'
import changeImagePathPrefix from '@/utils/helpers/changeImagePathPrefix'


export default /*#__PURE__*/_defineComponent({
  __name: 'SnackListDetail',
  props: {
  transId: null as any
},
  setup(__props) {

const props = __props



const { transId } = toRefs(props)

const endpointTransactionPp = 'transaction/v2/TransactionPps'
const store = useStore()
const snackDataSummary = ref()
const snackList = ref([]) as any

const getAllSnackData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${endpointTransactionPp}/Snack/Summary/ByTransactionPp/${transId.value}`).then((response) => {
    const { error, result } = response
    if (!error) {
      snackDataSummary.value = result
      snackList.value = result.TransactionPpSnackStocks.map((data: any) => ({
        ...data,
        Image: data.SnackImage ? `${environment.getApiImageBaseUrl()}${changeImagePathPrefix(data.SnackImage)}` : null,
      }))
    }
  })
  store.dispatch('hideLoading')
}

onMounted(() => {
  getAllSnackData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", null, [
        _hoisted_2,
        (_unref(snackList).length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(snackList), (data) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: data.Id
              }, [
                _createElementVNode("td", _hoisted_3, [
                  _createElementVNode("img", {
                    src: data.Image ?? _unref(defaulListImage),
                    class: "rounded-lg",
                    style: _normalizeStyle(data.image ? 'width: 50px;' : 'width: 40px;'),
                    alt: "SnackThumbnail"
                  }, null, 12, _hoisted_4),
                  _createElementVNode("div", null, _toDisplayString(data.SnackName ?? '-'), 1)
                ]),
                _createElementVNode("td", null, _toDisplayString(_unref(currencyNumberFormat)(data.SnackPrice ?? 0)), 1),
                _createElementVNode("td", null, _toDisplayString(`${_unref(numberFormat)(data.SoldQuantity ?? 0)} Pack`), 1),
                _createElementVNode("td", null, _toDisplayString(`${_unref(numberFormat)(data.CurrentStock ?? 0)} Pack`), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(currencyNumberFormat)(data.SoldAmount ?? 0)), 1)
              ]))
            }), 128))
          : (_openBlock(), _createElementBlock("tr", _hoisted_5, _hoisted_7))
      ])
    ])
  ]))
}
}

})